<div class="detail">
  <div>
    <a class="button mb-10" uiSref="^"><i class="fa fa-chevron-left mr-5"></i>Zpět na složku úkonu DOSS</a>
  </div>
  <h1>Nastavení úkonu DOSS</h1>

  <div *ngIf="loaded">
    <wizard [submitButtonName]="'Uložit'" [submitAction]="updateUkon" *ngIf="canEdit()">
      <wizard-tab [isValid]="ukonForm.isValid() && podrobneInformaceValid()">
        <ukon-form #ukonForm
                   [isUpdate]="true"
                   redirectToPageAfterDossSave="doss.akce.data.ukony.detail.update"
                   [redirectToPageParamsAfterDossSave]="{id: id}"
                   [ukon]="ukon">
        </ukon-form>

        <div *ngFor="let podrobneInformace of podrobneInformaceList.list; index as i" class="column-100 mb-10">
          <div *ngIf="podrobneInformaceKeys[i].includes('datum')">
            <label style="width:300px" class="required">{{podrobneInformace.stav}}
              <ng-container *ngIf="podrobneInformace.faze">({{podrobneInformace.faze}})</ng-container>
            </label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datum"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumVydani')">
            <label style="width:300px" class="required">Datum vydání</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumVydani"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumKoncePlatnosti')">
            <label style="width:300px" class="required">Datum konce platnosti</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumKoncePlatnosti"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('lhutaProOdvolani')">
            <label style="width:300px" class="required">Lhůta pro odvolání</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.lhutaProOdvolani"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('duvod')">
            <label style="width:300px" class="required">Důvod</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.duvod"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumJednani')">
            <label style="width:300px" class="required">Datum jednání</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumJednani"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('misto')">
            <label style="width:300px" class="required">Místo</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.misto"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumSetreni')">
            <label style="width:300px" class="required">Datum šetření</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumSetreni"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('lhuta')">
            <label style="width:300px" class="required">Datum lhůty</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.lhuta"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('zpusobUrgence')">
            <label style="width:300px" class="required">Způsob urgence</label>
            <div class="input"><gmt-select [data]="podrobneInformace"
                                           field="zpusobUrgence"
                                           [optionItems]="zpusobUrgenceOptions">
            </gmt-select></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('zpusobPodani')">
            <label style="width:300px" class="required">Způsob podání</label>
            <div class="input"><gmt-select [data]="podrobneInformace"
                                           field="zpusobPodani"
                                           [optionItems]="zpusobPodaniOptions">
            </gmt-select></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumDoruceni')">
            <label style="width:300px" class="required">Datum doručení</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumDoruceni"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('omezeniDelkyPlatnostiRozhodnuti')">
            <label style="width:300px" class="required">Datum omezení délky platnosti rozhodnutí</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.omezeniDelkyPlatnostiRozhodnuti"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('odvolaniPodal')">
            <label style="width:300px" class="required">Odvolání podal</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.odvolaniPodal"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('odvolaciOrgan')">
            <label style="width:300px" class="required">Odvolací orgán</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.odvolaciOrgan"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('podminkyVydani')">
            <label style="width:300px" class="required">Podmínky vydání</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.podminkyVydani"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('datumFikceSouhlasu')">
            <label style="width:300px" class="required">Datum fikce souhlasu</label>
            <div class="input"><input pick-a-date type="text" [(ngModel)]="podrobneInformace.datumFikceSouhlasu"/></div>
          </div>
          <div *ngIf="podrobneInformaceKeys[i].includes('poznamka')">
            <label style="width:300px" class="required">Poznámka</label>
            <div class="input"><input type="text" [(ngModel)]="podrobneInformace.poznamka"/></div>
          </div>
        </div>
      </wizard-tab>
    </wizard>
  </div>
</div>
<help [helpId]="helpIds.DOSS_UKON_UPDATE" class="cm-help-page"></help>
